module.exports = __webpack_public_path__ + "d81ad02d2a2898c9a886134e50700de0.gif";